import axios, { AxiosResponse } from 'axios';
import { RewardExperienceDto } from '@luckycart/xpn-types';

export interface FetchRewardExperienceResponse extends RewardExperienceDto {
  err?: string;
}

export class RewardExperienceService {
  private readonly hostRewardExperience: string;

  public constructor () {
    this.hostRewardExperience = process.env
      .REACT_APP_REWARD_EXPERIENCE_BASE_URL as string;
  }

  public async findRewardExperienceWithOperationAndConfiguration (
    shopperId: string,
    siteKey: string,
    experienceId: string,
    operationId: string
  ): Promise<FetchRewardExperienceResponse> {
    const url = `${this.hostRewardExperience}/v1/reward-experience`;
    const params = {
      shopperId,
      siteKey,
      experienceId,
      operationId,
    };
    const response: AxiosResponse<FetchRewardExperienceResponse> = await axios.get(
      url,
      { params }
    );
    if (response.data.err !== undefined) {
      throw new Error(response.data.err);
    }

    return response.data;
  }
}

export const rewardExperienceServiceInstance = new RewardExperienceService();
